import React, { useEffect, useRef } from "react";
import Img from "./Img";

export default function MarketInfoModal(props) {
    const ref = useRef(null);

    function handleClick(e) {
        e.stopPropagation();
        window.dispatchEvent(new CustomEvent('xs_closeModal', {detail: props.uniqueId}));
    }

    useEffect(() => {
        const el = ref.current;
        el.focus();
        el.addEventListener('blur', handleClick);
        return () => el.removeEventListener('blur', handleClick);
    }, []);

    return (
        <div className="c_55" data-modal-id={props.uniqueId} style={props.style} ref={ref} tabIndex={0}>
            <div className="c_55_1">
                <Img className="c_55_1_1" src="icon_info.svg" height="24px" width="24px" />
                <div className="c_55_1_2">{props.desc}</div>
                <Img className="c_55_1_3" src="icon_close.svg" height="32px" width="32px" onClick={handleClick} />
            </div>
            <hr className="c_55_2" />
            <div className="c_55_3">
                {props.children}
            </div>
        </div>
    );
}
